import { MediaDeliveryError } from './errors.js'

export const IMAGE_WIDTHS = Object.freeze([96, 192, 320, 480, 640, 768, 960, 1280, 1600, 1920, 2560])
export const IMAGE_QUALITY = 80

/**
 * @param {{ width:number }} input
 */
export function normalizeImagePolicy(input) {
  if (input === null || typeof input !== 'object') {
    throw invalidPolicy('image policy must be an object')
  }
  if (!Number.isInteger(input.width) || input.width <= 0) {
    throw invalidPolicy(`image policy width must be a positive integer: ${input.width}`)
  }
  const width = IMAGE_WIDTHS.find(candidate => candidate >= input.width) ?? IMAGE_WIDTHS.at(-1)
  return Object.freeze({ width })
}

/** @param {number} max_width */
export function imageCandidateWidths(max_width) {
  if (!IMAGE_WIDTHS.includes(max_width)) throw invalidPolicy(`unsupported image maximum width: ${max_width}`)
  return IMAGE_WIDTHS.filter(width => width <= max_width)
}

function invalidPolicy(message) {
  return new MediaDeliveryError(message, 'invalid_policy')
}
